
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/junior-math/login",
      function () {
        return require("private-next-pages/games/junior-math/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/junior-math/login"])
      });
    }
  